const proxyUrl = {
    pro: 'https://proxy.upliveapps.com/index/index',
    dev: 'http://awsbj-proxy.xingyunzhi.cn/index/index',
    stage: 'http://sg-proxy.xingyunzhi.cn/index/index'
};

const noop = () => {

};

const getCurrentEnv = () => {
    const env = Uplib.url.query('env');
    // if (!env) {
    //     if (document.domain === 'awsbj-game2u.xingyunzhi.cn') {
    //         return 'stage';
    //     }
    //     return 'pro';
    // }
    return env || 'pro';
};

const timeout = 5000;

class PbAjax {
    constructor() {
        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    do(cfg = {}, data, success = noop, timeoutFn = noop, fail = noop, respType = 'arraybuffer') {
        const prefix = proxyUrl[getCurrentEnv()];
        cfg.header = cfg.header || {};
        cfg.header.UserAgent = `${navigator.userAgent} channel/uplive-login`;
        const url = `${prefix}?${$.param(cfg)}`;
        let xhr;
        const timer = setTimeout(() => {
            timeoutFn();
        }, timeout);

        try {
            xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');

            xhr.open('POST', url, true);
            if (respType === 'arraybuffer') {
                xhr.responseType = respType;
            }
            xhr.timeout = timeout;
            try {
                xhr.send(respType === 'arraybuffer' ? data.toArrayBuffer() : data);
            } catch (e) {
                xhr.send();
            }
        } catch (e) {
            console.log(e);
            fail('你的浏览器不支持XMLHttpRequest');
        }

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                clearTimeout(timer);
                if (xhr.status === 200) {
                    if (!this.canceled) {
                        success(xhr.response);
                    }
                } else if (typeof fail === 'function') {
                    fail();
                }
            }
        };
    }


    cancel() {
        this.canceled = 1;
    }
}

export default PbAjax;



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/request/ajax.js